import { Box } from '@wix/design-system';
import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { FreeDomainMatchCycleLabel } from '../../FreeDomainMatchCycleLabel';
import { useCurrentModule } from '../../ModuleProvider';
import s from '../Checkout.scss';
export const CheckoutFreeDomainMatchCycle = () => {
  var _selectedCycle$cycleD, _selectedCycle$cycleD2;
  const module = useCurrentModule();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const isYearlyCycle = (selectedCycle == null || (_selectedCycle$cycleD = selectedCycle.cycleDuration) == null ? void 0 : _selectedCycle$cycleD.unit) === PurchaseOffering.DurationUnit.YEAR;
  const yearCount = (selectedCycle == null || (_selectedCycle$cycleD2 = selectedCycle.cycleDuration) == null ? void 0 : _selectedCycle$cycleD2.count) ?? 0;
  if (!isYearlyCycle || yearCount <= 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: "checkout-free-domain-match-cycle",
    margin: "SP3 0 SP2 0",
    width: "100%"
  }, /*#__PURE__*/React.createElement(FreeDomainMatchCycleLabel, {
    yearCount: yearCount,
    rowClassName: s.checkoutFreeDomainRow,
    textClassName: s.checkoutFreeDomainLabel
  }));
};
//# sourceMappingURL=CheckoutFreeDomainMatchCycle.js.map